import { render } from "./CareerView.vue?vue&type=template&id=35a985fc"
import script from "./CareerView.vue?vue&type=script&lang=js"
export * from "./CareerView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__